const manager_hotel = {
  average_concumption_per_night: "Average consumption per night",
};

export default manager_hotel;
